import ROUTES from '@consts/routes';
import CSAuthAxios from "@services/middlewares/CSAuthAxios";

export default [
  {
    path: '/cs/auth',
    meta: {
      middlewares: [CSAuthAxios],
    },
    component: () => import('@components/base_auths/LayoutAuth'),
    children: [
      {
        path: 'login',
        name: ROUTES.CS.AUTH.LOGIN,
        component: () => import("@components/base_auths/Login"),
      },
      {
        path: 'forgot-password',
        name: ROUTES.CS.AUTH.FORGOT_PASSWORD,
        component: () => import("@components/base_auths/ForgotPassword"),
      },
      {
        path: 'reset-password',
        name: ROUTES.CS.AUTH.RESET_PASSWORD,
        component: () => import("@components/base_auths/ResetPassword"),
      },
    ],
  }
]
